// extracted by mini-css-extract-plugin
export var postGrid = "y_bD";
export var wpPageLayout = "y_bC";
export var wpPageRelatedGrid = "y_bF";
export var wpPageRoot = "y_bB";